(function($) {

    $(document).on("svg.loaded", function(e, imgID) {
		var svg = $('#'+ imgID);
		if (svg.length) {
			var viewBox = svg.attr('viewBox');
			var viewBoxArray = viewBox.split(' ');
			var aspectRatio = (viewBoxArray[3] / viewBoxArray[2]) * 100;
			svg.wrap('<div class="svg-container"></div>');
			svg.parent().css('padding-bottom', aspectRatio +'%');
		}
    });

})( jQuery );
